<script setup>
import {onMounted, reactive, ref, watch} from 'vue'
import {State, can, go} from '@/paks/vu-app'
import DisplayEdit from './DisplayEdit.vue'
import {getDisplay} from './DashUtils'

const Fields = [
    {name: 'apply', title: 'Select', icon: '$click', width: '5%'},
    {name: 'edit', icon: '$edit', width: '5%'},
    {name: 'name'},
    {name: 'expression', title: 'Matching Expression' },
]

const page = reactive({
    builder: State.config.builder,
    display: null,
    fields: Fields,
    showEdit: false,
})

const table = ref(null)

watch(
    () => State.app.fullDisplay,
    async (v) => {
        if (table.value) {
            await table.value.update()
        }
    },
    {deep: true}
)

onMounted(() => { })

async function getData() {
    return State.app.fullDisplay.displays
}

async function clicked({action, item, items, column, rec, row}) {
    if (action == 'add') {
        if (!can('admin')) {
            return
        }
        editDisplay({})
    } else if (action == 'edit' || (action == 'cell' && column.name == 'edit')) {
        if (can('admin')) {
            editDisplay(item)
        }
    } else if (action == 'cell') {
        if (column.name == 'apply') {
            let display = getDisplay(item.name)
            State.app.setDisplay(display)
            go()
        }
    }
}

async function editDisplay(display) {
    page.showEdit = display ? true : false
    page.display = display ? Object.assign({}, display) : null
}
</script>

<template>
    <div class="view page display-list">
        <vu-help url="/doc/ui/designer/display-list.html" />
        <vu-table
            :data="getData"
            :fields="page.fields"
            :select="{actions: {Add: 0, Edit: 1, Delete: 2}, multi: true, property: 'select'}"
            name="display"
            nodata=" "
            options="dynamic,refilter,toolbar"
            ref="table"
            sort="name:asc"
            width="100%"
            @click="clicked">
            <template v-slot:more="props">
                <v-btn v-if="can('admin')" color="accent" @click="editDisplay({})">Add</v-btn>
            </template>
        </vu-table>

        <vu-panel v-model="page.showEdit" :widths="['550px']" @close="editDisplay">
            <DisplayEdit :display="page.display" @input="editDisplay" />
        </vu-panel>
    </div>
</template>

<style>
.display-list {
    .table-data {
        i {
            color: rgb(var(--v-theme-primary)) !important;
        }
    }
}
</style>